import { useContext } from 'react'
import AuthContext from '../AuthProvider/AuthContext'

const useAuthContext = () => {
    return useContext(AuthContext)
}

export default useAuthContext
